import React from 'react';

import PriceListSearchForm from './PriceListSearchForm';
import RowPriceList from './RowPriceList';
import { useIsMobile } from '@/app/_hooks/useIsMobile';
import ResponsiveRowPriceList from './ResponsiveRowPriceList';

export default function PriceListTable({ products, slug, currentPage }) {
  const isMobile = useIsMobile();
  return (
    <div className="p-4 border border-light-gray-300 rounded-md">
      <PriceListSearchForm slug={slug} />

      <table className="w-full mt-3">
        <thead>
          <tr className="font-bold border-b-2 border-light-gray-300 leading-12">
            <td>ردیف</td>
            <td>محصول</td>
            <td>قیمت</td>
            {!isMobile && (
              <>
                <td>به روزرسانی</td>
                <td>وضعیت</td>
                <td>خرید </td>
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {products.length > 0 ? (
            products.map((product, index) => {
              return !isMobile ? (
                <RowPriceList
                  key={product.id}
                  product={product}
                  index={index + 1}
                />
              ) : (
                <ResponsiveRowPriceList
                  key={product.id}
                  product={product}
                  index={index}
                />
              );
            })
          ) : (
            <div className="w-full">
              <p className="text-center block">نتیجه‌ای یافت نشد!</p>
            </div>
          )}
        </tbody>
      </table>
    </div>
  );
}
